import { render, staticRenderFns } from "./AccountingAccounts.vue?vue&type=template&id=4db33a78"
import script from "./AccountingAccounts.vue?vue&type=script&lang=js"
export * from "./AccountingAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports